import type { RouteObject } from 'react-router-dom';

/** Pages redirects /wt/* to weretradeit.de/*; both paths must reach the same page. */
export function withItDomainAliases(routes: RouteObject[]): RouteObject[] {
  const existing = new Set(routes.map(route => route.path));
  const aliases = routes
    .filter(route => route.path?.startsWith('wt/') && !existing.has(route.path.slice(3)))
    .map(route => ({
      ...route,
      path: route.path!.slice(3),
      id: route.id ? `it-domain-${route.id}` : undefined,
    }));
  return [...routes, ...aliases];
}
